export function signInClientHints() {
  if (typeof window === "undefined") return {};
  return {
    standalone: window.matchMedia?.("(display-mode: standalone)").matches === true || window.navigator.standalone === true,
    // iPadOS reports a Mac user agent; touch support distinguishes it.
    touch: Number(window.navigator.maxTouchPoints || 0) > 1,
  };
}

export const SIGN_IN_METHODS = {
  SMS: "SMS-verified browser", PIN: "Verified-browser PIN", EMAIL: "Verified email account",
  PASSWORD: "Email and password", GOOGLE: "Google account", MICROSOFT: "Microsoft account", PHONE: "Phone number",
  OTHER: "Other method", UNKNOWN: "Not recorded",
};

const GEO_STATUS = {
  PENDING: "Locating...", PRIVATE: "Private network", NO_IP: "IP not reported",
  NOT_FOUND: "Location not in database", UNAVAILABLE: "Location lookup unavailable",
};

export function signInLocation(event) {
  const place = event.location;
  if (!place) return GEO_STATUS[event.geoStatus] || "Location not recorded";
  return [place.city, place.region, place.countryCode === "US" ? "" : place.country].filter(Boolean).join(", ") || place.country;
}

export function matchesSignInSearch(event, search) {
  const term = String(search || "").trim().toLowerCase();
  if (!term) return true;
  return [event.name, event.detail, event.customerCode, event.ip, event.device?.label, signInLocation(event), SIGN_IN_METHODS[event.method]]
    .some(value => String(value || "").toLowerCase().includes(term));
}
